module.exports = __webpack_public_path__ + "static/addTask-a6339ea776912c1bb8a850a062f42e64.svg";